import { AxnAdminLoggingState } from "@idw-types/state/axn-admin-logging-state";
import { AxnAdminLoggingActionTypes, AxnAdminLoggingActions } from "../actions/axn-admin-logging-actions";

export const initialAxnAdminLoggingState: AxnAdminLoggingState = {
    isRefreshing: false,
    lastRefreshDate: null,
    refreshResults: null
};

export const axnAdminLoggingReducer = (
    state: AxnAdminLoggingState = initialAxnAdminLoggingState,
    action: AxnAdminLoggingActions
): AxnAdminLoggingState => {
    switch(action.type) {
        case AxnAdminLoggingActionTypes.SET_AXN_ADMIN_LOGGING_REFRESHING:
            return {
                ...state,
                isRefreshing: action.payload.isRefreshing
            };
        case AxnAdminLoggingActionTypes.SET_AXN_ADMIN_LOGGING_REFRESH_RESULTS:
            return {
                ...state,
                isRefreshing: false,
                refreshResults: action.payload.refreshResults,
                lastRefreshDate: action.payload.lastRefreshDate,
            };
        default:
            return state;
    }
};